import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { JsonReturn } from '../shared/interface/generic-interface';
import { Subject } from 'rxjs';

@Injectable()
export class BoxInfoAlertService {

  alertRouter: any = [];
  alertRouterPorRoteiro: any = [];
  abrirModalMensagemOc: boolean = false;
  mensagemOcorrenciaEvent$ = new Subject<{ mensagem: string; data: string }>();
  mensagemModal: string = '';
  dataModal: string = '';
  ocorrenciaAtualModal: any = null;
  abrirOcorrenciaCallback: ((item: any) => void) | null = null;

  constructor(
    private conService: ApiConService,
    private boxListTruckService: BoxListTruckService
  ) {

  }

  async getInfoAlertRouter() {
    try {
      const response: JsonReturn = await this.conService.patch('DCocorrencias/' + this.boxListTruckService.roteiroSelecionado);
      const data = response.response || [];
      this.alertRouter = [
        ...new Map(
          data.map((item) => [item.IdOcorrencia, item])
        ).values()
      ];
    }
    catch (Error) {
      console.log("CATCH________getInfoAlertRouter");
      console.log(Error);
      this.alertRouter = [];
    }
  }

  async getInfoAlertRouterRoteiro(roteiro) {
    try {
      console.log('getInfoAlertRouterRoteiro');
      const response: JsonReturn = await this.conService.patch('DCocorrencias/' + roteiro);
      const data = response.response || [];
      this.alertRouterPorRoteiro = [
        ...new Map(
          data.map((item) => [item.IdOcorrencia, item])
        ).values()
      ];
    }
    catch (Error) {
      console.log("CATCH________getInfoAlertRouterRoteiro");
      console.log(Error);
      this.alertRouterPorRoteiro = [];
    }
  }

  async getOcorrenciaMensagem(codigoOc) {
    try {
      const response: JsonReturn = await this.conService.patch('DCocorrenciaMensagem/' + `${codigoOc}`);
      return response.response;
    }
    catch (Error) {
      console.log("CATCH________getInfoAlertRouter");
      console.log(Error);
    }
  }
}
